module.exports = __webpack_public_path__ + "static/media/container1.7ae08708.jpg";